import React, { useMemo } from "react";

import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../_metronic/_partials/controls";
import { usePriceUIContext } from "./PriceUIContext";
import { PriceTable } from "./price-table/PriceTable";

export default function PriceCard() {
  
  const priceUIContext = usePriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      newPriceButtonClick: priceUIContext.newPriceButtonClick,
    };
  }, [priceUIContext]);

  return (
    <Card>
      <CardHeader title='Pricing Plan - Shopify'>
        <CardHeaderToolbar>
          <button
            type='button'
            className='btn btn-primary'
            onClick={priceUIProps.newPriceButtonClick}>
            <i className="fas fa-plus-circle"></i> Add New Plan
          </button>
        </CardHeaderToolbar>
      </CardHeader>{" "}  
      <CardBody>

        <PriceTable />
      </CardBody>
    </Card>
  );
}
